export default __webpack_public_path__ + "static/media/checkBox.b4da72fa.svg";